import { useStyles } from "./RCALibraryNumberCell.styles";
import RCAIcon from "pages/Corporate/RCA/images/rca_icon.svg";
import { IRCALibraryDescriptionCell } from "./RCALibraryNumberCell";
import { useTranslation } from "react-i18next";

const RCALibraryNumberCell = ({ rca }: IRCALibraryDescriptionCell) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={classes.descriptionWrapper}>
            <img src={RCAIcon} alt="RCA icon" />
            <span>{`${t("rca.rca")}-${rca.display_number}`}</span>
        </div>
    );
};

export default RCALibraryNumberCell;
